import { useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'

import { CustomerModel, ServiceModel } from '../../../domain/models'
import { fetchCustomer } from '../../../main/usecases'

import { useModalBox, useOnChangeDetect } from '../../contexts'
import { maskCpf } from '../../utils'
import {
  Button,
  ServiceForm,
  SubHeader,
  AccordionTable,
  EmptyData
} from '../../components'

import { PlusSvg } from '../../assets/icons/svgComponents'

import * as S from './styles'

const Services = ({ match }: any) => {
  const [customer, setCustomer] = useState<CustomerModel>()
  const [listToServices] = useState<ServiceModel[]>([])
  const { modalBox } = useModalBox()
  const { refresh } = useOnChangeDetect()

  const handleOpenNewServiceModal = () => {
    modalBox(<ServiceForm value={customer} />, 'Novo serviço', '34%', '86%')
  }

  const handleOpenEditModal = (service: ServiceModel) => {
    modalBox(
      <ServiceForm value={customer} service={service} />,
      'Editar serviço',
      '34%',
      '86%'
    )
  }

  const activeRouteDataRegistration = useMemo(() => {
    if (
      window.location.pathname ===
      `/meus-pacientes/${match?.params?.id}/dados-cadastrais`
    ) {
      return true
    }
    return false
  }, [match?.params?.id])

  const activeRouteService = useMemo(() => {
    if (
      window.location.pathname ===
      `/meus-pacientes/${match?.params?.id}/prontuario`
    ) {
      return true
    }
    return false
  }, [match?.params?.id])

  useEffect(() => {
    ;(async () => {
      try {
        const responseToCustomer = await fetchCustomer({
          id: match?.params?.id
        }).load()
        setCustomer(responseToCustomer)
        // const responseToService = await fetchListToService({
        //   id: match?.params?.id
        // }).load()
        // setListToServices(responseToService)
      } catch (error) {
        console.log(error)
      }
    })()
  }, [match.params.id, refresh])

  return (
    <S.Wrapper>
      {customer && (
        <SubHeader name={customer.nome} cpf={maskCpf(customer.cpf)} />
      )}
      <S.CardContainer>
        <S.HeaderContainer>
          <S.LinksContainer>
            <Link
              to={`/meus-pacientes/${match?.params?.id}/dados-cadastrais`}
              className={activeRouteDataRegistration ? 'active' : ''}
            >
              Dados Cadastrais
            </Link>
            <Link
              to={`/meus-pacientes/${match?.params?.id}/prontuario`}
              className={activeRouteService ? 'active' : ''}
            >
              Prontuário
            </Link>
          </S.LinksContainer>
        </S.HeaderContainer>
        <S.ActionsContainer>
          <Button initialIcon={<PlusSvg />} onClick={handleOpenNewServiceModal}>
            Novo Serviço
          </Button>
          {/* filter dados */}
        </S.ActionsContainer>
        <S.TableContainer>
          {listToServices?.length ? (
            <AccordionTable
              handleOpenEditModal={handleOpenEditModal}
              idCustomer={match?.params?.id}
              rows={listToServices}
            />
          ) : (
            <EmptyData>
              Para gerar um novo Laudo, clique em &quot;Novo Serviço&quot;
            </EmptyData>
          )}
        </S.TableContainer>
      </S.CardContainer>
    </S.Wrapper>
  )
}
export default Services
